import React, { useState } from "react";
import "./NavBar.css";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const isAdminEmail = (email) => {
	const adminEmails = process.env.REACT_APP_ADMIN_EMAIL.replace("[", "")
		.replace("]", "")
		.split(",")
		.map((email) => email.trim().toLowerCase());
	return adminEmails.includes(email.toLowerCase());
};

function Navbar() {
	const [menuOpen, setMenuOpen] = useState(false);
	// const [dropdownOpen, setDropdownOpen] = useState(false);
	const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
	const navigate = useNavigate();
	const { currentUser, logout } = useAuth();

	const handleNavigation = (path) => {
		if (path === "services") {
			navigate("/services");
		} else if (path === "home") {
			navigate("/");
		} else if (path === "about") {
			navigate("/about");
		} else if (path === "contact") {
			navigate("/contact");
		} else if (path === "resources") {
			navigate("/resources");
		} else if (path === "login") {
			navigate("/login");
		} else if (path === "new-blog") {
			navigate("/new-blog");
		} else if (path === "admin-upload") {
			navigate("/admin/upload");
		} else if (path === "new-newsletter") {
			navigate("/new-newsletter");
		} else {
			const element = document.getElementById(path);
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
		setMenuOpen(false);
		setAdminDropdownOpen(false);
	};

	const handleLogout = () => {
		logout();
		navigate("/");
	};

	return (
		<header className="App-header">
			<img
				src="/fullLogo.png"
				alt="Logo"
				className="mobile-logo"
				onClick={() => handleNavigation("home")}
			/>
			<nav>
				<button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
					<Menu />
				</button>
				<ul className={`nav-links ${menuOpen ? "open" : ""}`}>
					<li onClick={() => handleNavigation("home")}>Home</li>
					<li onClick={() => handleNavigation("services")}>Services</li>
					<li onClick={() => handleNavigation("about")}>About</li>
					<img
						src="/fullLogo.png"
						alt="Logo"
						className="fullLogo"
						onClick={() => handleNavigation("home")}
					/>
					<li onClick={() => handleNavigation("resources")}>Resources</li>
					<li onClick={() => handleNavigation("contact")}>Contact</li>
					{currentUser ? (
						isAdminEmail(currentUser.email) ? (
							<li
								className="admin-dropdown"
								onMouseEnter={() => setAdminDropdownOpen(true)}
								onMouseLeave={() => setAdminDropdownOpen(false)}
							>
								Admin
								<ul
									className={`admin-dropdown-menu ${
										adminDropdownOpen ? "show" : ""
									}`}
								>
									<li onClick={() => handleNavigation("new-newsletter")}>
										Add Newsletter
									</li>
									<li onClick={() => handleNavigation("new-blog")}>
										Add Blog Post
									</li>
									<li onClick={() => handleNavigation("admin-upload")}>
										Add Users
									</li>
									<li onClick={handleLogout}>Logout</li>
								</ul>
							</li>
						) : (
							<li onClick={handleLogout}>Logout</li>
						)
					) : (
						<li onClick={() => handleNavigation("login")}>Login</li>
					)}
				</ul>
			</nav>
		</header>
	);
}

export default Navbar;
